import { useContext, useEffect, useState } from "react";
import { WebEditorContext } from "../../../../../contexts";
import zlib from "react-zlib-js";
// import base64 from 'react-native-base64'
import { Buffer } from "buffer";

let keyStr = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';

export default function DxmlImage({ editorImage }) {
    const { editorFileRef } = useContext(WebEditorContext);
    const [name, setName] = useState('');
    const [data, setData] = useState('');

    const findCanvasName = (id) => {
        const canvases = editorFileRef.current.Others.find(x => x.DxmlContent?.includes("<Canvases"));
        if (canvases) {
            const parser = new DOMParser();
            const canvasesElement = parser.parseFromString(canvases.DxmlContent, "application/xml").documentElement;
            if (canvasesElement) {
                for (let i = 0; i < canvasesElement.children.length; i++) {
                    if (canvasesElement.children[i].getAttribute('ID') === id) {
                        return canvasesElement.children[i].getAttribute('Name');
                    }
                }
            }
        }
        return '';
    }

    const getCanvasId = (editorImageDef) => {
        const parser = new DOMParser();
        if (editorImageDef.DxmlImageChildContent) {
            const canvasElement = parser.parseFromString(editorImageDef.DxmlImageChildContent, "application/xml").documentElement;
            if (canvasElement.nodeName === 'Canvas') {
                return canvasElement.getAttribute('ID');
            }
        }
        return '';
    }

    const getCanvasName = (editorImageDef) => {
        let canvasId = getCanvasId(editorImageDef);
        if (!canvasId) {
            return '';
        }
        return findCanvasName(canvasId);
    }

    const setImageName = (editorImageDef) => {
        let imageName = editorImageDef.DxmlAttributes.Name;

        let canvasName = getCanvasName(editorImageDef);
        if (canvasName) {
            imageName = canvasName;
        }

        // Accessibility: Images must have alternate text. If the image does not have name, it sets default name 'image'
        if (!imageName) {
            imageName = "image";
        }

        setName(imageName);
    }

    const compressData = (originalData) => {
        return new Promise((res) => {
            zlib.unzip(new Buffer(originalData, 'base64'), (error, result) => {
                if (error) throw error;
                res(result);
            });
        });
    };

    const encodeFromByteArray = (input) => {
        var output = [];
        var chr1, chr2, chr3 = "";
        var enc1, enc2, enc3, enc4 = "";
        var i = 0;

        do {
            chr1 = input[i++];
            chr2 = input[i++];
            chr3 = input[i++];

            enc1 = chr1 >> 2;
            enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
            enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
            enc4 = chr3 & 63;

            if (isNaN(chr2)) {
                enc3 = enc4 = 64;
            } else if (isNaN(chr3)) {
                enc4 = 64;
            }

            output.push(
                keyStr.charAt(enc1) +
                keyStr.charAt(enc2) +
                keyStr.charAt(enc3) +
                keyStr.charAt(enc4)
            );
            
            chr1 = chr2 = chr3 = "";
            enc1 = enc2 = enc3 = enc4 = "";
        } while (i < input.length);

        return output.join('');
    }

    const loadData = async () => {
        let editorImageDef = editorFileRef.current.Images?.find(x => x.Id === editorImage.Id);
        if (!editorImageDef) {
            editorImageDef = editorImage;
        }

        setImageName(editorImageDef);

        if (editorImageDef.DxmlAttributes._xFl === '3') {
            // Image from Linux document container
            let rawData = await compressData(editorImageDef.DxmlAttributes.Data);
            let base64Data = encodeFromByteArray(rawData);
            setData(base64Data);
        } else {
            setData(editorImageDef.DxmlAttributes.Data);
        }
    }

    useEffect(() => {
        loadData();
    }, [])

    return (
        <img alt={name} style={editorImage.ReactCssStyle} src={`data:image/png;base64, ${data}`}></img>
    )
}